import { ChevronRight, Home } from 'lucide-react';
import { cn } from '@/lib/utils';

interface BreadcrumbItem {
  id: string | null;
  name: string;
}

interface LayerBreadcrumbProps {
  breadcrumbs: BreadcrumbItem[];
  onNavigate: (index: number) => void;
}

export function LayerBreadcrumb({ breadcrumbs, onNavigate }: LayerBreadcrumbProps) {
  if (breadcrumbs.length <= 1) return null;

  return (
    <nav aria-label="Layer navigation" data-guide="layer-breadcrumb" className="flex items-center gap-1 px-3 py-2 bg-card/90 backdrop-blur-sm rounded-lg border border-border shadow-sm text-sm pointer-events-auto" data-testid="layer-breadcrumb">
      {breadcrumbs.map((crumb, i) => (
        <div key={crumb.id ?? 'root'} className="flex items-center gap-1">
          {i > 0 && <ChevronRight className="w-3 h-3 text-muted-foreground" aria-hidden="true" />}
          <button
            onClick={() => onNavigate(i)}
            aria-label={i === 0 ? 'Root layer' : crumb.name}
            aria-current={i === breadcrumbs.length - 1 ? 'location' : undefined}
            data-testid={`breadcrumb-${i}`}
            className={cn(
              "px-2 py-0.5 rounded transition-colors",
              i === breadcrumbs.length - 1
                ? "text-foreground font-medium bg-accent/50"
                : "text-muted-foreground hover:text-foreground hover:bg-accent/30"
            )}
          >
            {i === 0 ? <Home className="w-3.5 h-3.5" aria-hidden="true" /> : crumb.name}
          </button>
        </div>
      ))}
    </nav>
  );
}
